import React from 'react'
import { observer } from 'mobx-react'
import useNavigationManager from '../hooks/use-navigation-manager'
import useSettingsManager from '../hooks/use-settings-manager'

function NavigationStep (props) {

  const nav_manager = useNavigationManager()
  const settings_manager = useSettingsManager()
  const strings = settings_manager.getStepSettings(nav_manager.getStepName(props.step))

  const classes = [
    'navigation-step',
    nav_manager.currentStep === props.step ? 'active' : '',
  ].filter(e => e).join(' ')

  return (
    <li
      className={classes}
      disabled={!props.accessible}
      onClick={props.accessible ? () => nav_manager.setStep(props.step) : null}
    >
      {strings.nav_title}
    </li>
  )
}

export default observer(NavigationStep)